module.exports = __webpack_public_path__ + "img/niño55.ecc82343.jpg";